import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { SAMPLE_UUID } from '@cli-constants/generators.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
import { sampleSchemaFieldValue } from './sample-schema-field-value.js'
export function sampleSchemaOutputValue(field: SchemaField): unknown {
  if (field.name === 'id') return SAMPLE_UUID
  if (field.name === 'createdAt' || field.name === 'updatedAt') return '2026-01-01T00:00:00.000Z'
  if (field.name === 'createdBy' || field.name === 'updatedBy') return 'user-id'

  if (field.type === 'select') {
    const sampleValue = sampleSchemaFieldValue(field)
    const values = Array.isArray(sampleValue) ? sampleValue : sampleValue ? [sampleValue] : []

    return values
      .filter((value): value is string => typeof value === 'string' && value.length > 0)
      .map((value) => ({
        label: field.options?.find((option) => option.value === value)?.label ?? value,
        value
      }))
  }

  if (field.type === 'relationship' && field.relationship && !field.multiple) {
    if (isUserRelationshipTarget(field.relationship)) {
      return {
        id: 'user-id',
        name: 'Example User',
        email: 'user@example.com'
      }
    }

    return {
      id: SAMPLE_UUID,
      name: 'Example related record',
      title: 'Example related record',
      slug: 'example-related-record',
      label: 'Example related record'
    }
  }

  if (field.type === 'group' && field.fields && field.fields.length > 0) {
    return Object.fromEntries(
      field.fields
        .filter((nestedField) => nestedField.name && !isLayoutField(nestedField.type))
        .map((nestedField) => [nestedField.name, sampleSchemaOutputValue(nestedField)])
    )
  }

  if (field.type === 'list' && field.fields && field.fields.length > 0) {
    return [
      Object.fromEntries(
        field.fields
          .filter((nestedField) => nestedField.name && !isLayoutField(nestedField.type))
          .map((nestedField) => [nestedField.name, sampleSchemaOutputValue(nestedField)])
      )
    ]
  }

  return sampleSchemaFieldValue(field)
}
